import { render, staticRenderFns } from "./ChildList.vue?vue&type=template&id=2fd1db88&scoped=true"
import script from "./ChildList.vue?vue&type=script&lang=ts"
export * from "./ChildList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd1db88",
  null
  
)

export default component.exports